import React from 'react';
import { Box, Typography, Grid } from '@mui/material';
import SentimentVeryDisatisfied from '@mui/icons-material/SentimentVeryDissatisfied';

const CommonObstacles = () => {
    const details = [
        [
            'PASSIVITY?',
            "Do you avoid conflict? Do you let her lead because you're scared you might get it wrong? Are you fully present?",
        ],
        [
            'COMMUNICATION?',
            "Do you argue about the same things over and over? Do you shut down or get anxious when things aren't going well?",
        ],
        [
            'NEEDS?',
            'Has the fire grown cold? Have you lost sight of each other? Have you lost yourself?',
        ],
    ];

    return (
        <Box
            pt={'4rem'}
            textAlign={'center'}
            sx={{
                backgroundColor: '#f2ece0',
                backgroundImage: 'url(/images/bgdots.png)',
            }}
        >
            <Typography variant="h2">
                The Most Common Obstacles to Building the Relationship You
                Deserve
            </Typography>
            <Typography variant="h6" textTransform={'uppercase'}>
                Can you relate to these struggles?
            </Typography>

            <Grid
                container
                justifyContent="center"
                alignItems="center"
                spacing={5}
                py={'3rem'}
                px={1}
            >
                {details.map((d, index) => (
                    <Grid key={index} item xs={12} md={4}>
                        <SentimentVeryDisatisfied
                            sx={{ fontSize: '7rem', color: '#c5a774' }}
                        />
                        <Typography variant="h5" textTransform={'uppercase'}>
                            {d[0]}
                        </Typography>
                        <Typography variant="h6">{d[1]}</Typography>
                    </Grid>
                ))}
            </Grid>
        </Box>
    );
};

export default CommonObstacles;
